import { Product } from '../types';

// ============================================
// CABLE MANAGEMENT & PROTECTION
// ============================================

// RUBBER GROMMETS
export const rubberGrommetProducts: Product[] = [
  {
    id: "grommet-001",
    name: "Rubber Grommet - 25.60mm x 19.30mm",
    slug: "rubber-grommet-25.60x19.30",
    category: "Cable Management",
    subcategory: "Rubber Grommet",
    description: "Rubber grommet for wire passage and protection. Size: 25.60mm x 19.30mm.",
    partNumber: "SI0100001",
    image: "/products/cable-management/rubber-grommet/SI0100001.jpg",
    specifications: {
      "Outer Dimension": "25.60mm",
      "Inner Dimension": "19.30mm",
      "Material": "Rubber",
      "Packing": "100 Pcs",
    },
    tags: ["grommet", "rubber", "wire-protection"],
    applications: ["Automotive", "Wire Passage", "Panel Mounting"],
  },
  {
    id: "grommet-002",
    name: "Rubber Grommet - 12.60mm x 12.90mm",
    slug: "rubber-grommet-12.60x12.90",
    category: "Cable Management",
    subcategory: "Rubber Grommet",
    description: "Rubber grommet for wire passage. Size: 12.60mm x 12.90mm.",
    partNumber: "SI0100002",
    image: "/products/cable-management/rubber-grommet/SI0100002.jpg",
    specifications: {
      "Outer Dimension": "12.60mm",
      "Inner Dimension": "12.90mm",
      "Material": "Rubber",
      "Packing": "100 Pcs",
    },
    tags: ["grommet", "rubber", "wire-protection"],
    applications: ["Automotive", "Wire Passage"],
  },
  {
    id: "grommet-003",
    name: "Rubber Grommet - 21.20mm x 12.60mm",
    slug: "rubber-grommet-21.20x12.60",
    category: "Cable Management",
    subcategory: "Rubber Grommet",
    description: "Rubber grommet for wire passage. Size: 21.20mm x 12.60mm.",
    partNumber: "SI0100003",
    image: "/products/cable-management/rubber-grommet/SI0100003.jpg",
    specifications: {
      "Outer Dimension": "21.20mm",
      "Inner Dimension": "12.60mm",
      "Material": "Rubber",
      "Packing": "100 Pcs",
    },
    tags: ["grommet", "rubber", "wire-protection"],
    applications: ["Automotive", "Wire Passage"],
  },
  {
    id: "grommet-004",
    name: "Rubber Grommet - Large",
    slug: "rubber-grommet-large",
    category: "Cable Management",
    subcategory: "Rubber Grommet",
    description: "Large rubber grommet for bulk wire passage.",
    partNumber: "SI0100004",
    image: "/products/cable-management/rubber-grommet/SI0100004.jpg",
    featured: true,
    specifications: {
      "Size": "Large",
      "Material": "Rubber",
      "Packing": "100 Pcs",
    },
    tags: ["grommet", "rubber", "large", "wire-protection"],
    applications: ["Automotive", "Heavy Duty Wire Passage"],
  },
  {
    id: "grommet-011",
    name: "Rubber Grommet - 70mm x 23mm",
    slug: "rubber-grommet-70x23",
    category: "Cable Management",
    subcategory: "Rubber Grommet",
    description: "Large rubber grommet. Size: 70mm x 23mm.",
    partNumber: "SI0100011",
    image: "/products/cable-management/rubber-grommet/SI0100011.jpg",
    specifications: {
      "Outer Dimension": "70mm",
      "Inner Dimension": "23mm",
      "Material": "Rubber",
      "Packing": "100 Pcs",
    },
    tags: ["grommet", "rubber", "large"],
    applications: ["Automotive", "Large Wire Bundle"],
  },
  {
    id: "grommet-012",
    name: "Rubber Grommet - 42mm x 37mm",
    slug: "rubber-grommet-42x37",
    category: "Cable Management",
    subcategory: "Rubber Grommet",
    description: "Rubber grommet. Size: 42mm x 37mm.",
    partNumber: "SI0100012",
    image: "/products/cable-management/rubber-grommet/SI0100012.jpg",
    specifications: {
      "Outer Dimension": "42mm",
      "Inner Dimension": "37mm",
      "Material": "Rubber",
      "Packing": "100 Pcs",
    },
    tags: ["grommet", "rubber"],
    applications: ["Automotive", "Wire Passage"],
  },
  {
    id: "grommet-013",
    name: "Rubber Grommet - 54mm x 59mm",
    slug: "rubber-grommet-54x59",
    category: "Cable Management",
    subcategory: "Rubber Grommet",
    description: "Large rubber grommet. Size: 54mm x 59mm.",
    partNumber: "SI0100013",
    image: "/products/cable-management/rubber-grommet/SI0100013.jpg",
    specifications: {
      "Outer Dimension": "54mm",
      "Inner Dimension": "59mm",
      "Material": "Rubber",
      "Packing": "100 Pcs",
    },
    tags: ["grommet", "rubber", "large"],
    applications: ["Automotive", "Large Wire Bundle"],
  },
  {
    id: "grommet-014",
    name: "Rubber Grommet - 70mm x 37mm",
    slug: "rubber-grommet-70x37",
    category: "Cable Management",
    subcategory: "Rubber Grommet",
    description: "Large rubber grommet. Size: 70mm x 37mm.",
    partNumber: "SI0100014",
    image: "/products/cable-management/rubber-grommet/SI0100014.jpg",
    specifications: {
      "Outer Dimension": "70mm",
      "Inner Dimension": "37mm",
      "Material": "Rubber",
      "Packing": "100 Pcs",
    },
    tags: ["grommet", "rubber", "large"],
    applications: ["Automotive", "Heavy Duty"],
  },
  {
    id: "grommet-015",
    name: "Rubber Grommet - 42mm",
    slug: "rubber-grommet-42",
    category: "Cable Management",
    subcategory: "Rubber Grommet",
    description: "Rubber grommet. Size: 42mm.",
    partNumber: "SI0100015",
    image: "/products/cable-management/rubber-grommet/SI0100015.jpg",
    specifications: {
      "Dimension": "42mm",
      "Material": "Rubber",
      "Packing": "100 Pcs",
    },
    tags: ["grommet", "rubber"],
    applications: ["Automotive", "Wire Passage"],
  },
  {
    id: "grommet-016",
    name: "Rubber Grommet - 37mm",
    slug: "rubber-grommet-37",
    category: "Cable Management",
    subcategory: "Rubber Grommet",
    description: "Rubber grommet. Size: 37mm.",
    partNumber: "SI0100016",
    image: "/products/cable-management/rubber-grommet/SI0100016.jpg",
    specifications: {
      "Dimension": "37mm",
      "Material": "Rubber",
      "Packing": "100 Pcs",
    },
    tags: ["grommet", "rubber"],
    applications: ["Automotive", "Wire Passage"],
  },
  {
    id: "grommet-017",
    name: "Rubber Grommet - 50mm x 38mm",
    slug: "rubber-grommet-50x38",
    category: "Cable Management",
    subcategory: "Rubber Grommet",
    description: "Rubber grommet. Size: 50mm x 38mm.",
    partNumber: "SI0100017",
    specifications: {
      "Outer Dimension": "50mm",
      "Inner Dimension": "38mm",
      "Material": "Rubber",
      "Packing": "100 Pcs",
    },
    tags: ["grommet", "rubber"],
    applications: ["Automotive", "Wire Passage"],
  },
];

// WIRE SEALS & DUMMY SEALS
export const wireSealProducts: Product[] = [
  {
    id: "seal-wire-001",
    name: "Wire Seal - Type 1",
    slug: "wire-seal-type-1",
    category: "Cable Management",
    subcategory: "Wire Seal",
    description: "Wire seal for waterproof wire passage in connectors. Type 1.",
    partNumber: "SI0002001",
    image: "/products/cable-management/seal/SI0002001.jpg",
    featured: true,
    specifications: {
      "Type": "Wire Seal",
      "Application": "Waterproof Connectors",
      "Packing": "100 Pcs",
    },
    tags: ["seal", "wire", "waterproof"],
    applications: ["Automotive", "Waterproof Connectors"],
  },
  {
    id: "seal-wire-002",
    name: "Wire Seal - Type 2",
    slug: "wire-seal-type-2",
    category: "Cable Management",
    subcategory: "Wire Seal",
    description: "Wire seal for waterproof wire passage. Type 2.",
    partNumber: "SI0002002",
    image: "/products/cable-management/seal/SI0002002.jpg",
    specifications: {
      "Type": "Wire Seal",
      "Application": "Waterproof Connectors",
      "Packing": "100 Pcs",
    },
    tags: ["seal", "wire", "waterproof"],
    applications: ["Automotive", "Waterproof Connectors"],
  },
  {
    id: "seal-dummy-003",
    name: "Dummy Seal - Type 3",
    slug: "dummy-seal-type-3",
    category: "Cable Management",
    subcategory: "Dummy Seal",
    description: "Dummy seal for unused connector cavities. Prevents water and dust ingress.",
    partNumber: "SI0002003",
    image: "/products/cable-management/seal/SI0002003.jpg",
    specifications: {
      "Type": "Dummy Seal",
      "Application": "Unused Cavities",
      "Packing": "100 Pcs",
    },
    tags: ["seal", "dummy", "waterproof"],
    applications: ["Automotive", "Connector Protection"],
  },
  {
    id: "seal-wire-004",
    name: "Wire Seal - Type 4",
    slug: "wire-seal-type-4",
    category: "Cable Management",
    subcategory: "Wire Seal",
    description: "Wire seal for waterproof wire passage. Type 4.",
    partNumber: "SI0002004",
    image: "/products/cable-management/seal/SI0002004.jpg",
    specifications: {
      "Type": "Wire Seal",
      "Application": "Waterproof Connectors",
      "Packing": "100 Pcs",
    },
    tags: ["seal", "wire", "waterproof"],
    applications: ["Automotive", "Waterproof Connectors"],
  },
  {
    id: "seal-wire-005",
    name: "Wire Seal - Type 5",
    slug: "wire-seal-type-5",
    category: "Cable Management",
    subcategory: "Wire Seal",
    description: "Wire seal for waterproof wire passage. Type 5.",
    partNumber: "SI0002005",
    image: "/products/cable-management/seal/SI0002005.jpg",
    specifications: {
      "Type": "Wire Seal",
      "Application": "Waterproof Connectors",
      "Packing": "100 Pcs",
    },
    tags: ["seal", "wire", "waterproof"],
    applications: ["Automotive", "Waterproof Connectors"],
  },
  {
    id: "seal-wire-006",
    name: "Wire Seal - Type 6",
    slug: "wire-seal-type-6",
    category: "Cable Management",
    subcategory: "Wire Seal",
    description: "Wire seal for waterproof wire passage. Type 6.",
    partNumber: "SI0002006",
    image: "/products/cable-management/seal/SI0002006.jpg",
    specifications: {
      "Type": "Wire Seal",
      "Application": "Waterproof Connectors",
      "Packing": "100 Pcs",
    },
    tags: ["seal", "wire", "waterproof"],
    applications: ["Automotive", "Waterproof Connectors"],
  },
  {
    id: "seal-wire-007",
    name: "Wire Seal - Type 7",
    slug: "wire-seal-type-7",
    category: "Cable Management",
    subcategory: "Wire Seal",
    description: "Wire seal for waterproof wire passage. Type 7.",
    partNumber: "SI0002007",
    image: "/products/cable-management/seal/SI0002007.jpg",
    specifications: {
      "Type": "Wire Seal",
      "Application": "Waterproof Connectors",
      "Packing": "100 Pcs",
    },
    tags: ["seal", "wire", "waterproof"],
    applications: ["Automotive", "Waterproof Connectors"],
  },
  {
    id: "seal-wire-008",
    name: "Wire Seal - Type 8",
    slug: "wire-seal-type-8",
    category: "Cable Management",
    subcategory: "Wire Seal",
    description: "Wire seal for waterproof wire passage. Type 8.",
    partNumber: "SI0002008",
    image: "/products/cable-management/seal/SI0002008.jpg",
    specifications: {
      "Type": "Wire Seal",
      "Application": "Waterproof Connectors",
      "Packing": "100 Pcs",
    },
    tags: ["seal", "wire", "waterproof"],
    applications: ["Automotive", "Waterproof Connectors"],
  },
  {
    id: "seal-wire-009",
    name: "Wire Seal - Type 9",
    slug: "wire-seal-type-9",
    category: "Cable Management",
    subcategory: "Wire Seal",
    description: "Wire seal for waterproof wire passage. Type 9.",
    partNumber: "SI0002009",
    image: "/products/cable-management/seal/SI0002009.jpg",
    specifications: {
      "Type": "Wire Seal",
      "Application": "Waterproof Connectors",
      "Packing": "100 Pcs",
    },
    tags: ["seal", "wire", "waterproof"],
    applications: ["Automotive", "Waterproof Connectors"],
  },
  {
    id: "seal-dummy-101",
    name: "Dummy Seal - Type 101",
    slug: "dummy-seal-type-101",
    category: "Cable Management",
    subcategory: "Dummy Seal",
    description: "Dummy seal for unused connector cavities.",
    partNumber: "SI0002101",
    image: "/products/cable-management/seal/SI0002101.jpg",
    specifications: {
      "Type": "Dummy Seal",
      "Application": "Unused Cavities",
      "Packing": "100 Pcs",
    },
    tags: ["seal", "dummy", "waterproof"],
    applications: ["Automotive", "Connector Protection"],
  },
  {
    id: "seal-dummy-102",
    name: "Dummy Seal - Type 102",
    slug: "dummy-seal-type-102",
    category: "Cable Management",
    subcategory: "Dummy Seal",
    description: "Dummy seal for unused connector cavities.",
    partNumber: "SI0002102",
    image: "/products/cable-management/seal/SI0002102.jpg",
    specifications: {
      "Type": "Dummy Seal",
      "Application": "Unused Cavities",
      "Packing": "100 Pcs",
    },
    tags: ["seal", "dummy", "waterproof"],
    applications: ["Automotive", "Connector Protection"],
  },
  {
    id: "seal-dummy-plug-111",
    name: "Dummy Plug - Type 111",
    slug: "dummy-plug-type-111",
    category: "Cable Management",
    subcategory: "Dummy Plug",
    description: "Dummy plug for sealing unused connector ports.",
    partNumber: "SI0002111",
    image: "/products/cable-management/seal/SI0002111.jpg",
    specifications: {
      "Type": "Dummy Plug",
      "Application": "Port Sealing",
      "Packing": "100 Pcs",
    },
    tags: ["seal", "dummy", "plug"],
    applications: ["Automotive", "Port Protection"],
  },
  {
    id: "seal-dummy-plug-112",
    name: "Dummy Plug - Type 112",
    slug: "dummy-plug-type-112",
    category: "Cable Management",
    subcategory: "Dummy Plug",
    description: "Dummy plug for sealing unused connector ports.",
    partNumber: "SI0002112",
    image: "/products/cable-management/seal/SI0002112.jpg",
    specifications: {
      "Type": "Dummy Plug",
      "Application": "Port Sealing",
      "Packing": "100 Pcs",
    },
    tags: ["seal", "dummy", "plug"],
    applications: ["Automotive", "Port Protection"],
  },
];

// CORRUGATED PIPES
export const corrugatedPipeProducts: Product[] = [
  {
    id: "corrugated-pipe",
    name: "Corrugated Pipe",
    slug: "corrugated-pipe",
    category: "Cable Management",
    subcategory: "Corrugated Pipe",
    description:
      "Flexible corrugated pipe used for wire protection and cable bundling. Rolls available in 25 meters.",
    image: "/products/cable-management/pipe/corrugated-pipe.jpg",
    variantType: "size",
    defaultVariant: "7mm",
  tags: ["corrugated", "pipe", "wire-protection"],
    applications: ["Automotive", "Cable Protection", "Wire Bundling"],

    variants: [
      { id: "cp-7", code: "SI0200007", name: "7mm", specifications: { Size: "7mm" } },
      { id: "cp-10", code: "SI0200010", name: "10mm", specifications: { Size: "10mm" } },
      { id: "cp-12", code: "SI0200012", name: "12mm", specifications: { Size: "12mm" } },
      { id: "cp-14", code: "SI0200014", name: "14mm", specifications: { Size: "14mm" } },
      { id: "cp-16", code: "SI0200016", name: "16mm", specifications: { Size: "16mm" } },
      { id: "cp-18", code: "SI0200018", name: "18mm", specifications: { Size: "18mm" } },
      { id: "cp-20", code: "SI0200020", name: "20mm", specifications: { Size: "20mm" } },
      { id: "cp-25", code: "SI0200025", name: "25mm", specifications: { Size: "25mm" } },
      { id: "cp-28", code: "SI0200028", name: "28mm", specifications: { Size: "28mm" } },
      { id: "cp-32", code: "SI0200032", name: "32mm", specifications: { Size: "32mm" } },
      { id: "cp-40", code: "SI0200040", name: "40mm", specifications: { Size: "40mm" } },
      { id: "cp-50", code: "SI0200050", name: "50mm", specifications: { Size: "50mm" } },
      { id: "cp-63", code: "SI0200063", name: "63mm", specifications: { Size: "63mm" } },
    ],
  },
];

// FLEXIBLE POLYAMIDE CONDUIT (Export Quality)
export const flexibleConduitProducts: Product[] = [
  {
    id: "polyamide-conduit",
    name: "Flexible Polyamide Conduit (Export Quality)",
    slug: "flexible-polyamide-conduit",
    category: "Cable Management",
    subcategory: "Flexible Conduit",
    description:
      "Export quality polyamide conduit for superior cable protection.",
    image: "/products/cable-management/pipe/flexibale-polyamide-pipe.jpg",
    variantType: "size",
    defaultVariant: "PG-07",
    tags: ["conduit", "polyamide", "flexible"],
    applications: ["Automotive", "Industrial"],

    variants: [
      { id: "pg7", code: "SI0200107", name: "PG-07", specifications: { ID: "6.5mm", OD: "10mm" } },
      { id: "pg9", code: "SI0200109", name: "PG-09", specifications: { ID: "10mm", OD: "13mm" } },
      { id: "pg11", code: "SI0200111", name: "PG-11", specifications: { ID: "12mm", OD: "15.8mm" } },
      { id: "pg13", code: "SI0200113", name: "PG-13", specifications: { ID: "14mm", OD: "18.5mm" } },
      { id: "pg16", code: "SI0200116", name: "PG-16", specifications: { ID: "17mm", OD: "21.2mm" } },
      { id: "pg21", code: "SI0200121", name: "PG-21", specifications: { ID: "23mm", OD: "28.5mm" } },
      { id: "pg29", code: "SI0200129", name: "PG-29", specifications: { ID: "29mm", OD: "34.5mm" } },
      { id: "pg36", code: "SI0200136", name: "PG-36", specifications: { ID: "36mm", OD: "42.5mm" } },
      { id: "pg48", code: "SI0200148", name: "PG-48", specifications: { ID: "48mm", OD: "54.5mm" } },
    ],
  },
];

// PG GLANDS WITH LOCK NUT
export const pgGlandProducts: Product[] = [
  {
    id: "pg-gland-locknut",
    name: "PG Gland with Lock Nut",
    slug: "pg-gland-locknut",
    category: "Cable Management",
    subcategory: "PG Gland",
    description:
      "PG cable glands with lock nut for secure cable entry and sealing.",
    image: "/products/cable-management/pipe/pg-gland-with-lock-nut.jpg",
    variantType: "size",
    defaultVariant: "PG-07",
    tags: ["pg-gland", "locknut", "cable-entry"],
    applications: ["Panel Mounting", "Cable Entry"],

    variants: [
      { id: "pg7", code: "SG0200107", name: "PG-07" },
      { id: "pg9", code: "SG0200109", name: "PG-09" },
      { id: "pg11", code: "SG0200111", name: "PG-11" },
      { id: "pg13", code: "SG0200113", name: "PG-13" },
      { id: "pg16", code: "SG0200116", name: "PG-16" },
      { id: "pg21", code: "SG0200121", name: "PG-21" },
      { id: "pg29", code: "SG0200129", name: "PG-29" },
      { id: "pg36", code: "SG0200136", name: "PG-36" },
      { id: "pg48", code: "SG0200148", name: "PG-48" },
    ],
  },
];

// METRIC GLANDS WITH LOCK NUT
export const metricGlandProducts: Product[] = [
  {
    id: "metric-gland-locknut",
    name: "Metric Gland with Lock Nut",
    slug: "metric-gland-locknut",
    category: "Cable Management",
    subcategory: "Metric Gland",
    description:
      "Metric cable glands with lock nut for metric conduit systems.",
    image: "/products/cable-management/pipe/metric-gland-with-lock-nut.jpg",
    variantType: "size",
    defaultVariant: "M-07",
    tags: ["metric-gland", "locknut"],
    applications: ["Automotive", "Industrial"],

    variants: [
      { id: "m7", code: "SGC0200107", name: "M-07" },
      { id: "m9", code: "SGC0200109", name: "M-09" },
      { id: "m11", code: "SGC0200111", name: "M-11" },
      { id: "m13", code: "SGC0200113", name: "M-13" },
      { id: "m16", code: "SGC0200116", name: "M-16" },
      { id: "m21", code: "SGC0200121", name: "M-21" },
      { id: "m29", code: "SGC0200129", name: "M-29" },
      { id: "m36", code: "SGC0200136", name: "M-36" },
      { id: "m48", code: "SGC0200148", name: "M-48" },
    ],
  },
];